import { memo, useState, useEffect } from "react";
import { getPriceLabel } from "./priceUtils";

const PriceAndLabel = ({item, isMapCard}) => {
  const [price, setPrice] = useState('');
  const [priceLabel, setPriceLabel] = useState('');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const price_label = getPriceLabel(item, isMapCard);
    setPriceLabel(isMobile && price_label?.bidTitMob ? price_label.bidTitMob : price_label?.bidTit);
    setPrice(price_label?.BidAmt);
  }, [isMobile]);

  return (
    <ul className={`fp_meta float-start mb0 ${isMapCard ? "mr10 ml5 lgmr0" : ""}`} tabIndex="0" key={`price-${item?.propertyId}`}>
      {priceLabel.length > 0 && price !== '' && <li className={`${isMapCard ? "price-labelM" : "price-label"}`}><span>{priceLabel}</span></li>}
      {price != '' && <li className={`list-inline-item ${isMapCard ? "price-value" : ""}`}><span className={isMapCard ? "price-value" : "fp_price"}>{price}</span></li>}
      {item?.category  === 'NPL' && item?.startingBid !== 'NA' && item?.startingBid !== '0' && item?.startingBid !== '' && item?.startingBid !== null && <li className={`list-inline-item ${isMapCard ? "price-value" : ""}`}><span className={isMapCard ? "price-value" : "fp_price"}>Listing Price: {'$' + item?.listingPrice}</span></li>}
    </ul>
  );
};

export default memo(PriceAndLabel);
